import React, { useState } from 'react';
import {
	ApButtonMain,
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import { PermissionsContext, PERMISSIONS } from 'contexts/PermissionsContext';
import { FileExportComponent } from '../SpendOpportunities/FileExportComponent';
import { useParams } from 'react-router-dom';

import {
	Wrapper,
	Content,
	LegalList,
	LegalTitle,
	Info,
	ButtonWrapper,
	ErrorText,
	DownloadWrapper,
	StyledIcon,
} from './styles';

const getExportUrl = fileName => `/files/${fileName}`;
const TAIL_SPEND_FILE_PREFIX = 'tailspendanalysis-transactions-SCBS-';
const SPEND_CUBE_FILE_PREFIX = 'tran-SCBS-';

export const Download = () => {
	const [isDownloading, setIsDownloading] = useState(false);
	const [error, setError] = useState(null);
	const { fileName } = useParams();

	const handleDownloadBtnClick = () => {
		setError(null);
		setIsDownloading(true);
	};

	const handleDownloadCallBack = message => {
		if (message) {
			setError(message);
		}

		setIsDownloading(false);
	};

	return (
		<React.Fragment>
			<PermissionsContext.Consumer>
				{({ permissions }) => {
					const canDownload = permissions.includes(PERMISSIONS.ExcelRead);
					let infoMessage = 'File';

					if (fileName.indexOf(TAIL_SPEND_FILE_PREFIX) !== -1) {
						infoMessage = 'Tail Spend Analysis';
					} else if (fileName.indexOf(SPEND_CUBE_FILE_PREFIX) !== -1) {
						infoMessage = 'Spend cube';
					}

					if (!canDownload) {
						return (
							<Wrapper>
								<Content>
									<Info>You don't have permission to download this file</Info>
								</Content>
							</Wrapper>
						);
					}

					return (
						<Wrapper>
							<Content>
								<Info>{infoMessage} is ready for download</Info>
								<LegalTitle>Private and confidential!</LegalTitle>
								<LegalList>
									<div
									>{`To download ${infoMessage} transactions you must:`}</div>
									<ul>
										<li>• Secure and protect the data</li>
										<li>• Only share this data with authorized parties</li>
										<li>
											• Delete it from your local drives after it is no longer
											useful
										</li>
									</ul>
								</LegalList>
								By clicking “Download File” you acknowledge and agree to fulfil
								your obligations listed above.
								<ButtonWrapper>
									{isDownloading ? (
										<ApLoaderDefault loaderText={() => <ApLoaderText />} />
									) : (
										<React.Fragment>
											{error && (
												<ErrorText>
													<StyledIcon
														iconName="outline_error"
														iconColor={colors.red2}
														iconSize={16}
													/>
													{error}
												</ErrorText>
											)}
											<DownloadWrapper>
												<ApButtonMain onClick={handleDownloadBtnClick}>
													Download File
												</ApButtonMain>
											</DownloadWrapper>
										</React.Fragment>
									)}
								</ButtonWrapper>
							</Content>
							{isDownloading && (
								<FileExportComponent
									url={getExportUrl(fileName)}
									onReady={handleDownloadCallBack}
									method="GET"
									fileName={fileName}
									requestResponse
								/>
							)}
						</Wrapper>
					);
				}}
			</PermissionsContext.Consumer>
		</React.Fragment>
	);
};

export default Download;
